import FileQueue from "./components/FileQueue";
import { useParams } from "react-router-dom";
import QueueCount from "./components/QueueCount";

export default function Queue() {
    const { filter, state } = useParams<{ filter?: string; state?: string }>();

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Queue</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">eFile</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Queue
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <QueueCount /> */}

                <FileQueue filter={filter ?? "all"} state={state ?? ""} />
            </div>
        </div>
    );
}
